<template>
  <div class="legal-page">
    <!-- Monogram Background Layer -->
    <div class="monogram-wrapper">
      <div class="monogram-background"></div>
    </div>

    <!-- Header Hero Section -->
    <section class="legal-hero">
      <div class="container">
        <div class="hero-content">
          <span class="hero-badge">{{ t('about.badge') || '// WHO WE ARE' }}</span>
          <h1 class="hero-title">{{ t('about.title') || 'BILLY B' }}</h1>
          <div class="hero-divider"></div>
          <p class="last-update">{{ t('about.subtitle') || 'Premium Streetwear Culture' }}</p>
        </div>
      </div>
    </section>

    <!-- Content Section -->
    <section class="legal-body">
      <div class="container">
        <div class="legal-layout">
          <!-- Sidebar Navigation -->
          <aside class="legal-sidebar desktop-only">
            <div class="sidebar-sticky">
              <nav class="side-nav">
                <a href="#vision" class="nav-anchor">
                  <span class="nav-num">01</span>
                  <span class="nav-text">{{ t('about.block1.title') }}</span>
                </a>
                <a href="#materia" class="nav-anchor">
                  <span class="nav-num">02</span>
                  <span class="nav-text">{{ t('about.block2.title') }}</span>
                </a>
                <a href="#design" class="nav-anchor">
                  <span class="nav-num">03</span>
                  <span class="nav-text">{{ t('about.block3.title') }}</span>
                </a>
              </nav>
            </div>
          </aside>

          <!-- Main Legal Content -->
          <div class="legal-main">
            <!-- Block 1: Vision -->
            <div id="vision" class="legal-section-card">
              <div class="card-inner">
                <div class="section-header">
                  <span class="section-index">// 01</span>
                  <h2>{{ t('about.block1.title') }}</h2>
                </div>
                <div class="section-content">
                  <p>{{ t('about.block1.text') }}</p>
                </div>
              </div>
            </div>

            <!-- Block 2: Materia -->
            <div id="materia" class="legal-section-card">
              <div class="card-inner">
                <div class="section-header">
                  <span class="section-index">// 02</span>
                  <h2>{{ t('about.block2.title') }}</h2>
                </div>
                <div class="section-content">
                  <p>{{ t('about.block2.text') }}</p>
                </div>
              </div>
            </div>

            <!-- Block 3: Design -->
            <div id="design" class="legal-section-card">
              <div class="card-inner">
                <div class="section-header">
                  <span class="section-index">// 03</span>
                  <h2>{{ t('about.block3.title') }}</h2>
                </div>
                <div class="section-content">
                  <p>{{ t('about.block3.text') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { useLanguage } from '@/composables/useLanguage'
const { t } = useLanguage()
</script>

<style scoped>
.legal-page {
  background-color: #ffffff;
  color: #000;
  min-height: 100vh;
  font-family: 'Montserrat', sans-serif;
  position: relative;
  overflow-x: hidden;
}

/* Texture Monogramma Billy B (Coerente con Countdown) */
.monogram-wrapper {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.monogram-background {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background-image: url("@/assets/images/logo.png");
  background-size: 120px auto;
  background-repeat: repeat;
  opacity: 0.22;
  transform: rotate(-15deg);
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 25px;
  position: relative;
  z-index: 1;
}

/* Hero Section - Extremely Compact */
.legal-hero {
  padding: 40px 0 25px;
  background-color: #000;
  text-align: center;
  position: relative;
  z-index: 2;
}

.hero-badge {
  display: block;
  font-size: 9px;
  font-weight: 800;
  color: var(--bright-teal);
  letter-spacing: 3px;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.hero-title {
  font-size: clamp(22px, 3vw, 28px);
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  margin-bottom: 12px;
  line-height: 1.1;
  color: #fff;
}

.hero-divider {
  width: 30px;
  height: 2px;
  background-color: var(--bright-teal);
  margin: 0 auto 12px;
}

.last-update {
  color: rgba(255, 255, 255, 0.4);
  font-size: 11px;
  font-style: italic;
}

/* Body Layout */
.legal-body {
  padding: 60px 0 100px;
  position: relative;
  z-index: 1;
}

.legal-layout {
  display: flex;
  gap: 50px;
}

@media (max-width: 992px) {
  .legal-layout {
    flex-direction: column;
    gap: 25px;
  }
  .legal-sidebar {
    flex: 0 0 auto;
    width: 100%;
  }
  .sidebar-sticky {
    position: static;
  }
}

/* Sidebar - Compact Box */
.legal-sidebar {
  flex: 0 0 240px;
  position: relative;
  z-index: 2;
}

.sidebar-sticky {
  position: sticky;
  top: 110px;
  background-color: #fff;
  padding: 25px 20px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.03);
}

.side-nav {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.nav-anchor {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 15px;
  text-decoration: none;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
}

.nav-num {
  font-family: 'Inter', sans-serif;
  font-size: 9px;
  font-weight: 800;
  color: var(--dark-teal);
  margin-top: 2px;
}

.nav-text {
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.nav-anchor:hover .nav-text {
  color: var(--dark-teal);
}

.nav-anchor:hover {
  border-left-color: var(--dark-teal);
  background: rgba(0, 0, 0, 0.02);
}

/* Main Content - Black Blocks */
.legal-main {
  flex: 1;
}

.legal-section-card {
  margin-bottom: 30px;
  scroll-margin-top: 130px;
}

.card-inner {
  background-color: #000;
  padding: 40px;
  border-radius: 4px;
  border-left: 4px solid var(--bright-teal);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.section-header {
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 15px;
}

.section-index {
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 800;
  color: var(--bright-teal);
  margin-bottom: 5px;
  letter-spacing: 2px;
}

.section-header h2 {
  font-size: 18px;
  font-weight: 800;
  text-transform: uppercase;
  color: #fff;
}

.section-content p {
  font-size: 15px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 15px;
  text-align: justify;
}

/* Mobile Adjustments */
@media (max-width: 1024px) {
  .legal-layout {
    gap: 30px;
  }
  .card-inner {
    padding: 30px 20px;
  }
}

@media (max-width: 768px) {
  .legal-hero {
    padding: 20px 0 15px;
  }
  .hero-title {
    font-size: 18px;
    padding: 0 5px;
    line-height: 1.3;
  }
  .last-update {
    font-size: 10px;
  }
  .legal-body {
    padding: 20px 0 40px;
  }
  .legal-layout {
    flex-direction: column;
    gap: 15px;
  }
  .legal-sidebar {
    display: none !important;
  }
  .card-inner {
    padding: 20px 15px;
  }
  .legal-section-card {
    margin-bottom: 15px;
  }
  .section-header h2 {
    font-size: 14px;
  }
  .section-content p {
    font-size: 13px;
    line-height: 1.5;
    text-align: left;
  }
  .monogram-background {
    background-size: 60px auto;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 10px;
  }
  .hero-title {
    font-size: 16px;
  }
  .card-inner {
    padding: 15px 10px;
  }
}
</style>
